import React, {Fragment, useEffect, useState} from 'react'
import {Dialog, Disclosure, Menu, Transition, MenuButton, MenuItem, MenuItems, Switch} from '@headlessui/react'
import {Bars3Icon, BellIcon, XMarkIcon} from '@heroicons/react/24/outline'

import PropertyNavigation from "../../components/common/navigation.component";
import MainNavigation from "../../components/common/navigation.component";
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import {Link, useLoaderData, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
    adminEventCard,
    copyTextToClipboard,
    getAttribute,
    getDate,
    getLocalDate,
    getSite,
    MetaTags,
    setUniqueEventAttribute,
    smallEventCard, toastSuccess
} from "../../components/common/utilities";
import {ChevronDownIcon, MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import {DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment/moment";
import FindVenues from "../venues/findVenues";
import {ToastContainer} from "react-toastify";
import {useTranslation} from "react-i18next";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function ImportDashboard() {
    const navigate = useNavigate();
    const logout = () => {
        window.location.href = '/logout';
    }

    let params = useParams();
    const venueID = params.venueID;
    const loaderdata = useLoaderData() as any;
    //console.log(loaderdata);
    const today = new Date();
    const dateString = today.toISOString().split('T')[0];

    const [events, setEvents] = useState([]);
    const [edp, setEDP] = useState([]);
    const [eventOffset, setEventOffset] = useState(0);
    const [eventLimit, setEventLimit] = useState(10);
    const [inQueue, setInQueue] = useState(0);
    const [inProgress, setInProgress] = useState(0);
    const [inPipeline, setInPipeline] = useState(0);
    const [limit, setLimit] = useState(100);
    const [NLPUrl, setNLPUrl] = useState([]);
    const [NLPData, setNLPData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addingEvent, setAddingEvent] = useState(false)
    const [gettingEvents, setGettingEvents] = useState(false)
    const [importString, setImportString] = useState('');
    const [empty, setEmpty] = useState(false);
    const [showAdmin, setShowAdmin] = useState(false);
    const [polling, setPolling] = useState(false);
    const [lang, setLang] = useState(getLang());


    function getLang()
    {
        const userlang = localStorage.getItem('userlang');
        if (userlang)
        {
            return userlang;
        }
        if (navigator.languages != undefined) return navigator.languages[0];
        return navigator.language;
    }

    const { t, i18n }:any = useTranslation('dashboard');

    let pollingInterval;

    const startPolling = (interval = 5000) => {

        stopPolling(); // Ensure no previous interval is running
        pollingInterval = setInterval(getEvents, interval);

    };

    const stopPolling = () => {
        console.log('polling interval is ', pollingInterval);
        if (pollingInterval) {
            clearInterval(pollingInterval);
            pollingInterval = null;
            console.log('polling stopped');

        }

    };


    var date = new Date();

    function isUrlValid(string) {
        try {
            new URL(string);
            return true;
        } catch (err) {
            return false;
        }
    }
    const getEvents = async (newlimit,admin) => {
        setGettingEvents(true)
        setInQueue(0);
        setInProgress(0);
        if(!admin)
        {
            admin = showAdmin;
        }
        else {
            setShowAdmin(true);
        }

        var url = `${process.env.REACT_APP_CLOUDAPI_URL}/v1/eventadmin/importqueue`;

        console.log('getting events, showing admin is: ', admin);

        if(!newlimit)
        {
           newlimit = limit;
        }

        var queue = 0;
        var progress = 0;
        var pipeline = 0;
        axios.post(url, {
            ticket: localStorage.getItem('ticket'), limit: newlimit, showadmin: admin
        }, { headers: {
                          'Content-Type': 'application/x-www-form-urlencoded'
                     }}).then(function (response) {
            // handle success
            //console.log("events", response);

            if(response.data.collection.length === 0)
            {
                setEmpty(true);
            }

            setEvents(response.data.collection);
            setGettingEvents(false)

            response.data.collection.forEach((event) => {
                //console.log(getAttribute(event, "statusText"));

                if (getAttribute(event, "statusText") === 'PENDING')
                {
                    queue++;
                }
                else if (getAttribute(event, "statusText") === 'IN_PROGRESS')
                {
                    progress++;
                }
                else if (getAttribute(event, "statusText") === 'IN_PIPELINE')
                {
                    pipeline++;
                }
            })
            setInQueue(queue);
            setInProgress(progress);
            setInPipeline(pipeline);
            /*if(admin)
            {
                setTimeout(() => getEvents(newlimit,admin), 5000)
            }
            else {
                setTimeout(() => getEvents(newlimit,admin), 5000)
            }*/
            //pollEvents(null);

        }).catch(function (error) {
            // handle error
            console.log(error);
            setGettingEvents(false)
        });
    }

    const pollEvents = (url) => {
        setCount(count + 1);
        setTimeout(() => doPoll(), 15000)
    }

    const doPoll = () => {
        getEvents(limit,showAdmin);
    }

    const [count, setCount] = useState(0);

    const getMoreEvents = () => {
        getEvents(eventOffset,showAdmin);
    }

    useEffect(() => {

        getEvents(false,showAdmin);
        //startPolling()
        if(count === 0)
        {
            pollEvents(null);
        }

    }, []);

    // EDIT EVENT DIALOG

    const [open, setOpen] = useState(false);

    type SchemaEvent = {
        [key: string]: any; // ?? variable key
        name: string;
    };
    type SchemaLocation = {
        [key: string]: any; // ?? variable key
        name: string;
    };

    const [eventData, setEventData] = useState<SchemaEvent>();
    const [venueData, setVenueData] = useState<SchemaLocation>();


    const createEvent = (e) => {
        e.preventDefault();
        console.log('posting ', eventData);
        axios.post(`${process.env.REACT_APP_API_URL}/go/api/event/create.do`, eventData, {}).then(function (response) {
            // handle success
            console.log(response);
            //setRooms(response.data.collection);
            //window.location.href = '/onboarding/room/'+response.data.collection[0]['guid'];

        });
    }



    const viewEvent = (event) => {
        setOpen(true);
        console.log(event);
        setEventData(event);
        setVenueData(event.location);
        let eventID = getAttribute(event,"eventID")
        let apipath = "/v1/event/"+eventID+"/"+lang;


        axios.get(`${process.env.REACT_APP_CLOUDAPI_URL}`+apipath, {
            params: {
            }
        }).then(function (response) {
            // handle success
            //console.log(response);
            let eventData = response.data;
            setEventData(eventData);

        });

    }

    function changeStartDate(e)
    {
        console.log(e._d);
        var d = new Date(e._d);
        console.log(d.toISOString());
        setEventData({
                         ...eventData, localStartDate: e._i
                     })
    }

    function changeEndDate(e)
    {
        console.log(e._d);
        var d = new Date(e._d);
        console.log(d.toISOString());
        setEventData({
                         ...eventData, localEndDate: e._i
                     })
    }

    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if(button === 'setAd')
        {
            console.log('setAd');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key,value,unique,remove,eventid);

            let gogo:any = {};
            if(eventData.gogo)
            {
               gogo = eventData.gogo;
               gogo.ad = value;
            }

            setEventData({
            ...eventData,
            gogo
                          });

        }
        else if(button === 'manageAudience')
        {
            console.log('managing audience');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = true;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute('pgg.audience.'+key,'pgg.audience.'+value,unique,remove,eventid);

            toastSuccess('Audience set '+key+' Remove: '+remove);

        }

        /*let venueid = e.target.dataset.venueid;
        if (venueid !== undefined)
        {
            console.log(`Event bubbled up to div from `, venueid);
            //console.log(eventData);
            let venuename = e.target.dataset.venuename;
            let venueimage = e.target.dataset.venueimage;

            var locationData = eventData.location;
            locationData.name = venuename;
            locationData.image = venueimage;
            locationData['@id'] = venueid;

            setVenueData(locationData);

            setEventData({
                             ...eventData, location: {
                    locationData
                }

                         })
            console.log(eventData);

        }*/


    }

    const importURL = (event,eventurl) => {
        console.log(event);
        event.currentTarget.classList.toggle('fa-spin');
        setAddingEvent(true)
        if (!isUrlValid(eventurl))
        {
            alert("Invalid URL");
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_CLOUDAPI_URL}/v1/eventadmin/importqueue/add`, {
                url: eventurl,
                importmore: true,
                ticket: localStorage.getItem('ticket')
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                //event.target.elements.text.value = '';
                setAddingEvent(false)
                event.currentTarget.classList.toggle('fa-spin');
                getEvents(null,showAdmin);
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }

    }

    const changeLimit = (newlimit) => {
        setLimit(newlimit);
        getEvents(newlimit,showAdmin);
    }

    const toggleSort = (sort) => {
        console.log("show admin", sort);
        setEvents([]);
        setShowAdmin(sort);
        stopPolling();
        //setTimeout(() => getEvents(false,sort), 1000);
        //startPolling();
    }

    const importEvent = (event) => {
        event.preventDefault()
        setAddingEvent(true)
        if (!isUrlValid(event.target.elements.text.value))
        {
            alert("Invalid URL");
            setImportString('');
            setAddingEvent(false)
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_CLOUDAPI_URL}/v1/eventadmin/importqueue/add`, {
                url: event.target.elements.text.value,
                eventurl: event.target.elements.text.value,
                ticket: localStorage.getItem('ticket'),
                importmore: true
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                event.target.elements.text.value = '';
                setAddingEvent(false)
                setImportString('');
                getEvents(null,showAdmin);
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }

    }

    const handlePasteImport = event => {
        var eventurl = event.clipboardData.getData('text');
        setImportString(eventurl);
        setAddingEvent(true)
        if (!isUrlValid(eventurl))
        {
            alert("Invalid URL");
            setImportString('');
            return;
        }
        else
        {
            axios.post(`${process.env.REACT_APP_CLOUDAPI_URL}/v1/eventadmin/importqueue/add`, {
                eventurl: eventurl,
                url: eventurl,
                ticket: localStorage.getItem('ticket')
            }, {
                           headers: {
                               'Content-Type': 'application/x-www-form-urlencoded'
                           },
                       }).then(function (response) {
                // handle success
                setAddingEvent(false)
                getEvents(null,showAdmin);
                setImportString('');
            }).catch(function (error) {
                // handle error
                console.log(error);
                setAddingEvent(false)

            });
        }
    };

    return (<>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full">
        <body class="h-full">
        ```
      */}
        <div className="min-h-full dark:bg-white bg-white">
            <MetaTags title={'Import Events'} description={'Import events from external sources'} />
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-40" onClose={setOpen}>
                    <div className="fixed inset-0"/>

                    <div className="fixed inset-0 overflow-hidden">
                        <div className="absolute inset-0 overflow-hidden">
                            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-2">
                                <Transition.Child
                                    as={Fragment}
                                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                                    enterFrom="translate-x-full"
                                    enterTo="translate-x-0"
                                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                                    leaveFrom="translate-x-0"
                                    leaveTo="translate-x-full"
                                >
                                    <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                                        <div
                                            className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                                            <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll overflow-x-hidden py-1">
                                                <div className="px-2 sm:px-6">
                                                    <div className="flex items-start justify-between">
                                                        <Dialog.Title
                                                            className="text-base font-semibold leading-6 text-gray-900">
                                                            Action Panel
                                                        </Dialog.Title>
                                                        <div className="ml-3 flex h-7 items-center">
                                                            <button
                                                                type="button"
                                                                className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                                onClick={() => setOpen(false)}
                                                            >
                                                                <span className="absolute -inset-2.5"/>
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                                    {eventData && eventData.name && <div className="px-4 py-5 sm:p-6" onClick={(event) => clickedEvent(event)}>
                                                        {adminEventCard(eventData)}
                                                    </div>}
                                                    {eventData && !eventData.name && <div className={'px-4 py-5 sm:p-6 text-green-800 justify-items-center'}><div><i className="fa-duotone fa-circle-notch fa-spin"></i></div></div> }

                                                </div>
                                            </div>
                                            <div className="flex flex-shrink-0 justify-end px-4 py-4">
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                                                    onClick={() => setOpen(false)}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <SidebarNavigation/>

            <div className="lg:pl-72">

                <main className="mt-2">
                    <div className="px-4 sm:px-6 lg:px-8">
                        <div className=" bg-white z-30">
                            <div className="ml-4 mt-2">
                                <h3 className="text-base font-semibold leading-6 text-gray-900">{t('importevents')}</h3>
                                <p className={'text-gray-600 leading-6 mt-2'}>{t('importeventsdescription')}</p>
                                <form onSubmit={importEvent} id={'import-full'}>
                                    <div className="mt-2 flex rounded-md shadow-sm">
                                        <div className="relative flex flex-grow items-stretch focus-within:z-10">
                                            <input
                                                type="text"
                                                name="text"
                                                id="input-full"
                                                className="block w-full md:h-16 md:text-2xl rounded-none rounded-l-md border-0 py-1.5 pl-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 "
                                                placeholder="https://..."
                                                value={importString}
                                                onChange={e => setImportString(e.target.value)}
                                                onPaste={pasteEvent => handlePasteImport(pasteEvent)}
                                            />
                                        </div>
                                        <button
                                            type="submit"
                                            className="relative -ml-px inline-flex items-center gap-x-1.5 px-3 py-2 text-sm font-semibold text-gray-900 bg-white ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                        >
                                            {addingEvent &&
                                             <i className="fa-solid fa-circle-notch fa-spin"></i>}{!addingEvent &&
                                                                                                   <span>Add</span>}
                                        </button>
                                        <button
                                            type="button"
                                            className="rounded-r-md bg-pg_green px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-green-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                            onClick={() => getEvents(null,showAdmin)}
                                        >
                                            {!gettingEvents &&
                                             <i className="fa-duotone fa-arrows-rotate"></i>}{gettingEvents &&
                                                                                              <i className="fa-duotone fa-arrows-rotate fa-spin"></i>}
                                        </button>
                                    </div>
                                </form>

                            </div>
                            {/*<div className={'ml-4 mt-2'}>
                                <h3 className="text-base font-semibold leading-6 text-gray-900">Show admin</h3>

                                <Switch
                                    checked={showAdmin}
                                    onChange={toggleSort}
                                    className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                                >
                                    <span className="sr-only">Use setting</span>
                                    <span
                                        aria-hidden="true"
                                        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                    />
                                </Switch>
                            </div>
                            <div className="ml-4 mt-2 flex-shrink-0 pt-2">
                                <h3 className="text-base font-semibold leading-6 text-gray-900">Limit</h3>

                                <Menu as="div" className="relative text-left">
                                    <div>
                                        <MenuButton
                                            className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                            {limit}
                                            <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400"
                                                             aria-hidden="true"/>
                                        </MenuButton>
                                    </div>

                                    <MenuItems
                                        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                    >
                                        <div className="py-1">
                                            <MenuItem>
                                                {({focus}) => (<a
                                                        href="#" onClick={() => changeLimit(100)}
                                                        className={classNames(focus ? 'bg-gray-100' : 'bg-white', ' text-gray-900 block px-4 py-2 text-sm')}
                                                    >
                                                        100
                                                    </a>)}
                                            </MenuItem>
                                            <MenuItem>
                                                {({focus}) => (<a
                                                        href="#" onClick={() => changeLimit(250)}
                                                        className={classNames(focus ? 'bg-gray-100' : 'bg-white', ' text-gray-900 block px-4 py-2 text-sm')}
                                                    >
                                                        250
                                                    </a>)}
                                            </MenuItem>
                                            <MenuItem>
                                                {({focus}) => (<a
                                                        href="#" onClick={() => changeLimit(500)}
                                                        className={classNames(focus ? 'bg-gray-100' : 'bg-white', ' text-gray-900 block px-4 py-2 text-sm')}
                                                    >
                                                        500
                                                    </a>)}
                                            </MenuItem>
                                            <MenuItem>
                                                {({focus}) => (<a
                                                        href="#" onClick={() => changeLimit(1000)}
                                                        className={classNames(focus ? 'bg-gray-100' : 'bg-white', ' text-gray-900 block px-4 py-2 text-sm')}
                                                    >
                                                        1000
                                                    </a>)}
                                            </MenuItem>
                                        </div>
                                    </MenuItems>
                                </Menu>

                            </div>*/}
                        </div>

                        <div>
                            <div className="px-4 sm:px-6 lg:px-2">
                                {gettingEvents && <div className="p-4 text-gray-800 flex justify-center w-full">
                                    <div className={'text-pg_yellow'}><i
                                            className="fa-2x fa-duotone fa-loader fa-spin"></i></div>
                                </div>}
                                {empty && <div className="p-4 text-gray-800 flex justify-center w-full">
                                     <div className={'text-pg_yellow'}><i className="fa-duotone fa-exclamation"></i> No
                                         Events found
                                     </div>
                                 </div>
                                }
                                <div className="-mx-4 mt-2 sm:-mx-0">

                                    <table className="min-w-full divide-y divide-gray-300">
                                        <thead className="bg-white">
                                        <tr>
                                            <th scope="col"
                                                className="relative isolate py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                                            </th>
                                            <th scope="col"
                                                className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                                                {events && events.length > 0 && <>{inQueue} in queue, {inPipeline} in pipeline, {inProgress} in progress</>}
                                                <div
                                                    className="absolute inset-y-0 right-full -z-10 w-screen border-b border-b-gray-200"/>
                                                <div
                                                    className="absolute inset-y-0 left-0 -z-10 w-screen border-b border-b-gray-200"/>
                                            </th>
                                            <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                                                <span className="sr-only">Edit</span>
                                            </th>
                                        </tr>
                                        </thead>

                                        <tbody>

                                        {events && events.map((event, index) => (
                                            <tr key={getAttribute(event, "remoteID")}
                                                className={'even:bg-gray-50 odd:bg-white'}>
                                                <td className="relative py-1 pr-1 text-sm font-medium text-gray-900">
                                                    {getAttribute(event, "eventID") && getAttribute(event, "statusText").toString() === 'SUCCESS' &&
                                                     <div className={'text-green-800'}><i
                                                             className="fa-2x fa-sharp fa-regular fa-check"></i></div>}
                                                    {getAttribute(event, "eventID") && getAttribute(event, "statusText").toString() === 'PARTIALLY_CREATED' &&
                                                     <div className={'text-green-800'}><i
                                                             className="fa-2x fa-duotone fa-bell-exclamation"></i>
                                                     </div>}

                                                    {!getAttribute(event, "eventID") && getAttribute(event, "statusText") === 'PENDING' &&
                                                     <div className={'text-pg_yellow'}><i
                                                             className="fa-2x fa-duotone fa-loader fa-spin"></i></div>}
                                                    {!getAttribute(event, "eventID") && getAttribute(event, "statusText") === 'IN_PROGRESS' &&
                                                     <div className={'text-pg_yellow'}><i
                                                             className="fa-2x fa-duotone fa-spinner-third fa-spin"></i>
                                                     </div>}
                                                    {!getAttribute(event, "eventID") && getAttribute(event, "statusText") === 'IN_PIPELINE' &&
                                                     <div className={'text-green-900'}><i
                                                             className="fa-2x fa-duotone fa-spinner-third fa-spin"></i>
                                                     </div>}
                                                    {!getAttribute(event, "eventID") && getAttribute(event, "statusText") === 'FAILED' &&
                                                     <div className={'text-red-700'}><i
                                                             className="fa-2x fa-duotone fa-bell-exclamation"></i>
                                                     </div>}

                                                    {!getAttribute(event, "eventID") && getAttribute(event, "statusText") === 'BLOCKED' &&
                                                     <div className={'text-red-700'}><i
                                                             className="fa-duotone fa-solid fa-traffic-light-stop"></i>
                                                     </div>}

                                                </td>
                                                <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-small text-gray-900 sm:w-auto sm:max-w-none sm:pl-0" >
                                                    <div onClick={getAttribute(event, 'eventID') ? () => viewEvent(event) : undefined} className={'cursor-pointer'}>
                                                    <div className={'font-medium'}>{event.title}</div>
                                                    <div>{getAttribute(event, 'showTime') && getDate(getAttribute(event, 'showTime'),'GMT')}</div>
                                                    </div>
                                                    {!getAttribute(event,"eventID") && getAttribute(event, "statusText") === 'FAILED' && <div className={'text-red-700 text-ellipsis overflow-hidden ...'}>{getAttribute(event, "description")}</div>}
                                                    <div
                                                        className={'text-xs text-gray-500 cursor-pointer'}  onClick={() => copyTextToClipboard(getAttribute(event, "eventUrl"))}>{getSite(getAttribute(event, "eventUrl"))}: {getAttribute(event, "remoteID")} </div>

                                                    {getAttribute(event, "eventID") && getAttribute(event, "statusText").toString() === 'PARTIALLY_CREATED' && <div className={'text-xs text-gray-500 cursor-pointer'}>{getAttribute(event, "statusText")} | {getAttribute(event, "description")}</div> }

                                                    <div
                                                        className="absolute bottom-0 right-full h-px w-screen bg-gray-100"/>
                                                    <div
                                                        className="absolute bottom-0 left-0 h-px w-screen bg-gray-100"/>
                                                </td>
                                                <td className="relative py-4 pl-3 text-right text-sm font-medium">
                                                    {getAttribute(event, 'eventUrl') && <div>
                                                        <button  onClick={(e) => importURL(e,getAttribute(event, 'eventUrl'))} className={'px-3 py-2 text-center text-sm font-semibold'}>
                                                            <i className="fa-duotone fa-arrows-rotate text-green-800"></i></button>
                                                    </div>}
                                                </td>
                                            </tr>))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </main>
            </div>
        </div>
        <ToastContainer autoClose={800} theme={'dark'} />

    </>)
}
